/* Componente per la visualizzazione del menù a tendina che permette di cambiare l'ordine del percorso scelto */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { useTranslation } from 'react-i18next';
const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(0),
    minWidth: 60,

  },
  selectEmpty: {
    marginTop: theme.spacing(0),
  },

}));

export default function Ordinamento(props) {
  const classes = useStyles();
  const [status, setStatus] = React.useState(0);
  const { i18n } = useTranslation();
  const handleChange = (event) => {
    props.callback(event.target.value)
    setStatus(event.target.value);
  };

  return (
    
        <FormControl className={classes.formControl}>
        <Select
        
          value={status}
          onChange={handleChange}
          displayEmpty
          className={classes.selectEmpty}
          inputProps={{ 'aria-label': 'Without label' }}
          
        >
          <MenuItem value={0}>
            <em className={"ordinamentoLabel"}>{i18n.t('Orario di arrivo')}</em>
          </MenuItem>
          <MenuItem value={1}><em className={"ordinamentoLabel"}>{i18n.t('Orario di partenza')}</em></MenuItem>
           <MenuItem value={2}><em className={"ordinamentoLabel"}>{i18n.t('Piu veloce')}</em></MenuItem>
          <MenuItem value={3}><em className={"ordinamentoLabel"}>{i18n.t('Minor tratto a piedi')}</em></MenuItem>
          <MenuItem value={4}><em className={"ordinamentoLabel"}>{i18n.t('Minor cambi')}</em></MenuItem>
        </Select>
      </FormControl>
   )}